<template>
  <div class="lable_div vue_flex vue_column">
    <div class="lable_div_title width_100">
      <p>项目班组花名册台账1</p>
    </div>
    <el-form label-position="left" :inline="true">
      <el-form-item>
        <el-input v-model="listQuery.name" placeholder="搜索关键字" />
      </el-form-item>
      <el-form-item>
        <el-input v-model="listQuery.name" placeholder="创建人员" />
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="listQuery.value1"
          type="date"
          placeholder="创建时间"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="eventClick('search')">
          搜索
        </el-button>
        <el-button @click="eventClick('reset')"> 重置 </el-button>
      </el-form-item>
    </el-form>
    <div class="width_100">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        highlight-current-row
        height="70vh"
        :header-cell-style="getHeaderStyle"
      >
        <el-table-column
          prop="index"
          label="甲方单位 名称"
          align="center"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="总 （分）包单位名称"
          align="center"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="姓名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="性别"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="民族"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="家庭住址"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="身份证号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="工作岗位（工种）"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="进场时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="退场时间"
          align="center"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="工资卡号"
          align="center"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="联系方式"
          align="center"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="项目负责人签名"
          align="center"
          width="140"
        ></el-table-column>
        <el-table-column
          align="center"
          label="操作"
          width="180"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="row">
            <el-button type="primary" size="small" @click="handleDetail(row)">
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listQuery: {
        name: "",
        value1: "",
      },
      tableData: [
        {
          date: "2016-05-03",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
      ],
    };
  },
  created() {},

  methods: {
    getHeaderStyle({ row, column, rowIndex, columnIndex }) {
      return {
        backgroundColor: "#e8e8e8", // 蓝色背景
        color: "black", // 文字颜色
      };
    },
  },
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/permission/directive.vue